export enum EnumContactMethod {
  NEIGHBOURS = 'NEIGHBOURS',
  REFERRED = 'REFERRED',
  REPURCHASE = 'REPURCHASE',
  RENTAL = 'RENTAL',
  FACEBOOK = 'FACEBOOK',
  WEBSITE = 'WEBSITE',
  BILLBOARD_PERIFERICO = 'BILLBOARD_PERIFERICO',
  BILLBOARD_CN = 'BILLBOARD_CN',
  OTHER_BILLBOARD = 'OTHER_BILLBOARD',
  OTHER_MAGAZINE = 'OTHER_MAGAZINE',
  TV = 'TV',
  EMAIL = 'EMAIL',
  NARANJO_MALL = 'NARANJO_MALL',
  EVENT = 'EVENT',
  INSTAGRAM = 'INSTAGRAM',
  OTHER = 'OTHER'
}

export const NAME_CONTACT_METHOD = {
  [EnumContactMethod.NEIGHBOURS]: 'Vecinos',
  [EnumContactMethod.REFERRED]: 'Referido',
  [EnumContactMethod.REPURCHASE]: 'Recompra',
  [EnumContactMethod.RENTAL]: 'Renta',
  [EnumContactMethod.FACEBOOK]: 'Facebook',
  [EnumContactMethod.WEBSITE]: 'Página Web',
  [EnumContactMethod.BILLBOARD_CN]: 'Valla CN',
  [EnumContactMethod.BILLBOARD_PERIFERICO]: 'Valla Periférico',
  [EnumContactMethod.OTHER_BILLBOARD]: 'Otra valla',
  [EnumContactMethod.OTHER_MAGAZINE]: 'Otra revista',
  [EnumContactMethod.TV]: 'Television',
  [EnumContactMethod.EMAIL]: 'Correo electrónico',
  [EnumContactMethod.NARANJO_MALL]: 'Naranjo Mall',
  [EnumContactMethod.EVENT]: 'Evento',
  [EnumContactMethod.INSTAGRAM]: 'Instagram',
  [EnumContactMethod.OTHER]: 'Otro'
}

export const CONTACT_METHOD_OPTIONS = [
  { label: NAME_CONTACT_METHOD[EnumContactMethod.NEIGHBOURS], value: EnumContactMethod.NEIGHBOURS },
  { label: NAME_CONTACT_METHOD[EnumContactMethod.REFERRED], value: EnumContactMethod.REFERRED },
  {
    label: NAME_CONTACT_METHOD[EnumContactMethod.BILLBOARD_CN],
    value: EnumContactMethod.BILLBOARD_CN
  },
  {
    label: NAME_CONTACT_METHOD[EnumContactMethod.BILLBOARD_PERIFERICO],
    value: EnumContactMethod.BILLBOARD_PERIFERICO
  },
  {
    label: NAME_CONTACT_METHOD[EnumContactMethod.OTHER_BILLBOARD],
    value: EnumContactMethod.OTHER_BILLBOARD
  },
  { label: NAME_CONTACT_METHOD[EnumContactMethod.WEBSITE], value: EnumContactMethod.WEBSITE },
  {
    label: NAME_CONTACT_METHOD[EnumContactMethod.OTHER_MAGAZINE],
    value: EnumContactMethod.OTHER_MAGAZINE
  },
  { label: NAME_CONTACT_METHOD[EnumContactMethod.TV], value: EnumContactMethod.TV },
  { label: NAME_CONTACT_METHOD[EnumContactMethod.EVENT], value: EnumContactMethod.EVENT },
  { label: NAME_CONTACT_METHOD[EnumContactMethod.EMAIL], value: EnumContactMethod.EMAIL },
  {
    label: NAME_CONTACT_METHOD[EnumContactMethod.NARANJO_MALL],
    value: EnumContactMethod.NARANJO_MALL
  },
  { label: NAME_CONTACT_METHOD[EnumContactMethod.FACEBOOK], value: EnumContactMethod.FACEBOOK },
  { label: NAME_CONTACT_METHOD[EnumContactMethod.INSTAGRAM], value: EnumContactMethod.INSTAGRAM },
  { label: NAME_CONTACT_METHOD[EnumContactMethod.RENTAL], value: EnumContactMethod.RENTAL },
  { label: NAME_CONTACT_METHOD[EnumContactMethod.REPURCHASE], value: EnumContactMethod.REPURCHASE },
  { label: NAME_CONTACT_METHOD[EnumContactMethod.OTHER], value: EnumContactMethod.OTHER }
]
